import React from 'react'
import { useNavigate } from 'react-router-dom';
import cartImage from '../images/cartimage.webp';
function CartDiv() {
    const navigate=useNavigate();
    return (
        <div>
            <div className='cart' onClick={() => navigate("/my-cart")}>
                <img src={cartImage} alt="cart" className="cart-image" />
            </div>
        </div>
    )
}

export default CartDiv;
